import { useContext } from "react";
import QuizContext from "../contexts/quiz";

const useQuiz = () => {
  const context = useContext(QuizContext);
  return context;
};

export default useQuiz;
